import axios from "axios";
import { API_BASE } from "./constants";

export const api = axios.create({ baseURL: API_BASE, withCredentials: true, timeout: 30000 });

api.interceptors.request.use((config) => {
  const initData = window.Telegram?.WebApp?.initData;
  if (initData) config.headers["x-telegram-init-data"] = initData;
  return config;
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(new Error(error.response?.data?.error || error.message || "Request failed"))
);
